module.exports = __webpack_public_path__ + "static/media/bottom.0b559b79.webp";